export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/transcripts.db06376.svg";